var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { BlockAtom, getPx, SylController, SylPlugin } from '@syllepsis/adapter';
import { NodeSelection, TextSelection } from 'prosemirror-state';
import { addAttrsByConfig, createFileInput, getFixSize, getFromDOMByConfig, isMatchObject, isObjectURL, setDOMAttrByConfig, } from '../../utils';
import { checkDomain, constructAttrs, correctSize, getImageFileList, getInputImageFiles, transformBlobFromObjectURL, } from './utils';
var PLUGIN_NAME = 'image';
var maxWidth = window.innerWidth - 40;
var BASE_CONFIG = {
    uploader: function () { return Promise.resolve(''); },
    uploadBeforeInsert: false,
    placeholder: '',
    uploadType: 'blob',
    listenDrop: true,
    listenPaste: true,
    maxLength: 20,
    uploadMaxWidth: 375,
};
// parse the DOM of image which generated by the the ImagePlugin
var parseSylDOM = function (dom, fixClass, captionClass, addAttributes) {
    var image = dom.querySelector('img');
    if (!image)
        return false;
    var caption = dom.querySelector(captionClass);
    var fixer = dom.querySelector(fixClass);
    var alt = (caption && (caption.innerText || caption.value)) || '';
    var src = (image && image.src) || '';
    var width = image.width;
    var height = image.height;
    var name = image.getAttribute('name') || '';
    var align = dom.getAttribute('align');
    if (!align && fixer) {
        var className = fixer.className;
        if (className.includes('left'))
            align = 'left';
        else if (className.includes('right'))
            align = 'right';
    }
    var attrs = { src: src, alt: alt, width: width, height: height, align: align, name: name };
    addAttributes && getFromDOMByConfig(addAttributes, dom, attrs);
    return attrs;
};
var uploadImg = function (editor, src, fileName, config) { return __awaiter(void 0, void 0, void 0, function () {
    var res, uploader, uploadType, onUploadError, deleteFailedUpload, uploadRes, err_1, nodeInfos;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                res = src;
                uploader = config.uploader, uploadType = config.uploadType, onUploadError = config.onUploadError, deleteFailedUpload = config.deleteFailedUpload;
                if (!uploader)
                    throw new Error('Must provide uploader!');
                if (!isObjectURL(src)) return [3 /*break*/, 2];
                return [4 /*yield*/, transformBlobFromObjectURL(src)];
            case 1:
                res = _a.sent();
                _a.label = 2;
            case 2:
                if (typeof res !== 'string' && uploadType === 'file') {
                    res = new File([res], fileName, { type: res === null || res === void 0 ? void 0 : res.type });
                }
                _a.label = 3;
            case 3:
                _a.trys.push([3, 5, , 6]);
                return [4 /*yield*/, uploader(res, {
                        src: src,
                    })];
            case 4:
                uploadRes = _a.sent();
                if (typeof uploadRes === 'string')
                    return [2 /*return*/, { src: uploadRes || src }];
                return [2 /*return*/, __assign({ src: src }, uploadRes)];
            case 5:
                err_1 = _a.sent();
                if (deleteFailedUpload) {
                    nodeInfos = editor.getExistNodes(PLUGIN_NAME);
                    nodeInfos.some(function (_a) {
                        var node = _a.node, pos = _a.pos;
                        if (node.attrs.src === src) {
                            editor.delete(pos, 1, { addToHistory: false });
                            return true;
                        }
                    });
                }
                if (onUploadError)
                    onUploadError(res, err_1);
                else
                    throw err_1;
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); };
var insertImageInEditor = function (editor, dataInfos, config) {
    var _a, _b, _c;
    var state = editor.view.state;
    var pos = state.selection.from;
    var $pos = state.doc.resolve(pos);
    var imageType = (_a = state.schema.nodes) === null || _a === void 0 ? void 0 : _a.image;
    var images = __spreadArray([], dataInfos, true);
    var insertNodes = { type: 'doc', content: [] };
    // when depth >= 2 and contained in table, inserting images will not update the selection,causes it to be inserted in reverse order
    var isInTable = ((_c = (_b = $pos.node(1)) === null || _b === void 0 ? void 0 : _b.type) === null || _c === void 0 ? void 0 : _c.name) === 'table' && $pos.depth >= 2;
    if (isInTable) {
        images.reverse();
    }
    images.forEach(function (_a) {
        var _b, _c;
        var image = _a.image, attrs = _a.attrs;
        if (!image || !attrs)
            return;
        var imageAttrs = __assign({ width: config.uploadMaxWidth ? Math.min(image.naturalWidth, config.uploadMaxWidth) : image.naturalWidth, name: image.getAttribute('name') || '', alt: '', align: ((_c = (_b = imageType === null || imageType === void 0 ? void 0 : imageType.attrs) === null || _b === void 0 ? void 0 : _b.align) === null || _c === void 0 ? void 0 : _c.default) || 'center' }, attrs);
        if (isInTable) {
            editor.insert({ type: PLUGIN_NAME, attrs: imageAttrs });
        }
        else {
            insertNodes.content.push({ type: PLUGIN_NAME, attrs: imageAttrs });
        }
    });
    if (insertNodes.content.length && !isInTable)
        editor.insert(insertNodes, pos);
};
// get the picture file and judge whether to upload it in advance
var insertImageWithFiles = function (editor, files, config) { return __awaiter(void 0, void 0, void 0, function () {
    var results;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.all(files.map(function (f) {
                    return new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, url, attrs, image;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _a = config.checkBeforeInsert;
                                    if (!_a) return [3 /*break*/, 2];
                                    return [4 /*yield*/, config.checkBeforeInsert(f)];
                                case 1:
                                    _a = !(_b.sent());
                                    _b.label = 2;
                                case 2:
                                    if (_a)
                                        return [2 /*return*/, resolve({})];
                                    url = window.URL.createObjectURL(f);
                                    attrs = { src: url };
                                    image = document.createElement('img');
                                    image.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var uploadRes;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!config.uploadBeforeInsert) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, uploadImg(editor, url, f.name, config)];
                                                case 1:
                                                    uploadRes = _a.sent();
                                                    if (!uploadRes)
                                                        resolve({});
                                                    else
                                                        attrs = __assign(__assign({}, attrs), uploadRes);
                                                    _a.label = 2;
                                                case 2:
                                                    resolve({ attrs: attrs, image: image });
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); };
                                    image.onerror = function (e) { return __awaiter(void 0, void 0, void 0, function () {
                                        var onUploadError;
                                        return __generator(this, function (_a) {
                                            onUploadError = config.onUploadError;
                                            onUploadError && onUploadError(f, e);
                                            resolve({});
                                            return [2 /*return*/];
                                        });
                                    }); };
                                    image.src = attrs.src;
                                    image.setAttribute('name', f.name);
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }))];
            case 1:
                results = _a.sent();
                insertImageInEditor(editor, results, config);
                return [2 /*return*/];
        }
    });
}); };
var updateImageUrl = function (editor, props, config) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, src, name, state, imageAttrs, attrs, nodePos, $pos, curNode;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                maxWidth = editor.view.dom.scrollWidth - 40;
                _a = props.attrs, src = _a.src, name = _a.name;
                if (props.state === undefined)
                    props.state = {};
                state = props.state;
                imageAttrs = {};
                _b.label = 1;
            case 1:
                _b.trys.push([1, , 7, 8]);
                if (!(state.uploading || (!isObjectURL(src) && checkDomain(src, config)))) return [3 /*break*/, 3];
                return [4 /*yield*/, correctSize(props.attrs)];
            case 2:
                imageAttrs = _b.sent();
                return [3 /*break*/, 6];
            case 3:
                state.uploading = true;
                return [4 /*yield*/, uploadImg(editor, src, name, config)];
            case 4:
                attrs = _b.sent();
                state.uploading = false;
                if (!attrs)
                    return [2 /*return*/];
                return [4 /*yield*/, constructAttrs(props.attrs, attrs)];
            case 5:
                imageAttrs = _b.sent();
                _b.label = 6;
            case 6:
                nodePos = props.getPos();
                if (typeof nodePos !== 'number')
                    return [2 /*return*/];
                $pos = editor.view.state.doc.resolve(nodePos);
                curNode = $pos.nodeAfter;
                // confirm the image node exist
                if (!curNode || curNode.type.name !== PLUGIN_NAME || curNode.attrs.src !== src)
                    return [2 /*return*/];
                if (!isMatchObject(__assign(__assign({}, props.attrs), imageAttrs), props.attrs)) {
                    editor.insertCard(PLUGIN_NAME, __assign(__assign({}, props.attrs), imageAttrs), { index: $pos.pos, deleteSelection: false });
                    editor.delete($pos.pos + 1, 1, { addToHistory: false });
                }
                return [3 /*break*/, 8];
            case 7:
                state.uploading = false;
                return [7 /*endfinally*/];
            case 8: return [2 /*return*/];
        }
    });
}); };
var createImageFileInput = function (editor, config) {
    var input = createFileInput({
        multiple: true,
        accept: config.accept || 'image/*',
        onChange: function (e) {
            var files = getInputImageFiles(e);
            insertImageWithFiles(editor, files, config);
        },
        getContainer: function () { return editor.root; },
    });
    return input;
};
var ImageController = /** @class */ (function (_super) {
    __extends(ImageController, _super);
    function ImageController(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.toolbar = {
            className: 'image',
            tooltip: 'image',
            icon: '',
            handler: function () { return _this.fileInput.click(); },
        };
        _this.command = {
            insertImages: function (editor, files) { return insertImageWithFiles(editor, files, _this.props); },
            updateImageUrl: function (editor, props) { return updateImageUrl(editor, props, _this.props); },
            getConfiguration: function () { return _this.props; },
        };
        _this.eventHandler = {
            handleClickOn: function (editor, view, pos, node, nodePos, event) {
                if (node.type.name === PLUGIN_NAME) {
                    var caption = event.target.closest('input');
                    if (caption) {
                        if (caption)
                            caption.focus();
                        var newTextSelection = TextSelection.create(view.state.doc, nodePos);
                        view.dispatch(view.state.tr.setSelection(newTextSelection));
                        return true;
                    }
                    // when the currently selected image is a picture, but the system behaves as a cursor, correct the selection.(real is 'Range')
                    var state = view.state, dispatch = view.dispatch;
                    var curSelection = window.getSelection();
                    if (curSelection && curSelection.type === 'Caret') {
                        dispatch(state.tr.setSelection(NodeSelection.create(view.state.doc, nodePos)));
                        return true;
                    }
                    return false;
                }
                return false;
            },
            handlePaste: function (editor, view, e) {
                var event = e;
                if ((_this.props && !_this.props.listenPaste) || !event.clipboardData) {
                    return false;
                }
                var files = getImageFileList(event.clipboardData.files);
                if (!files.length || event.clipboardData.getData('text/html')) {
                    return false;
                }
                editor.command.image.insertImages(files);
                return true;
            },
            handleDOMEvents: {
                drop: function (editor, view, e) {
                    var event = e;
                    if (view.dragging || (_this.props && !_this.props.listenDrop) || !event.dataTransfer) {
                        return false;
                    }
                    var files = getImageFileList(event.dataTransfer.files);
                    if (!files.length)
                        return false;
                    editor.command.image.insertImages(files);
                    e.preventDefault();
                    return true;
                },
            },
        };
        _this.editorWillUnmount = function () {
            _this.editor.root.removeChild(_this.fileInput);
        };
        if (Object.keys(props).length)
            _this.props = __assign(__assign({}, BASE_CONFIG), props);
        _this.fileInput = createImageFileInput(editor, _this.props);
        editor.root.appendChild(_this.fileInput);
        return _this;
    }
    return ImageController;
}(SylController));
var Image = /** @class */ (function (_super) {
    __extends(Image, _super);
    function Image(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.name = PLUGIN_NAME;
        _this.traceSelection = false;
        _this.parseDOM = [
            {
                tag: 'div.syl-image-wrapper',
                getAttrs: function (dom) {
                    return parseSylDOM(dom, '.syl-image-fixer', '.syl-image-caption', _this.props.addAttributes);
                },
            },
            {
                tag: 'img',
                getAttrs: function (dom) {
                    if (!dom.src)
                        return false;
                    var attrWidth = dom.getAttribute('width');
                    var attrHeight = dom.getAttribute('height');
                    var width = getPx(dom.style.width || (attrWidth && attrWidth + "px") || '', 16);
                    var height = getPx(dom.style.height || (attrHeight && attrHeight + "px") || '', 16);
                    if (!width || isNaN(width))
                        width = 0;
                    if (!height || isNaN(height))
                        height = 0;
                    if (width > maxWidth) {
                        if (height)
                            height = height / (width / maxWidth);
                        width = maxWidth;
                    }
                    var formattedAttrs = {
                        src: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || '',
                        name: dom.getAttribute('name') || '',
                        align: (dom.getAttribute('align') || undefined),
                        width: width,
                        height: height,
                    };
                    getFromDOMByConfig(_this.props.addAttributes, dom, formattedAttrs);
                    return formattedAttrs;
                },
            },
        ];
        _this.toDOM = function (node) {
            var _a = node.attrs, align = _a.align, width = _a.width, height = _a.height, attrs = __rest(_a, ["align", "width", "height"]);
            setDOMAttrByConfig(_this.props.addAttributes, node, attrs);
            if (width)
                attrs.width = getFixSize(width);
            if (height)
                attrs.height = getFixSize(height);
            var renderSpec = ['img', attrs];
            if (_this.inline)
                return renderSpec;
            var alignAttrs = _this.props.disableAlign ? {} : { align: align || 'center' };
            var outputArray = ['div', __assign({ class: 'syl-image-wrapper' }, alignAttrs), renderSpec];
            attrs.alt && outputArray.push(['p', { class: 'syl-image-caption' }, attrs.alt]);
            return outputArray;
        };
        _this.attrs = {
            src: {
                default: '',
            },
            alt: {
                default: '',
            },
            name: {
                default: '',
            },
            width: {
                default: 0,
            },
            height: {
                default: 0,
            },
            align: {
                default: 'center',
            },
        };
        addAttrsByConfig(props.addAttributes, _this);
        _this.props = props;
        var _a = _this.attrs, align = _a.align, alt = _a.alt, rest = __rest(_a, ["align", "alt"]);
        // @ts-ignore
        _this.attrs = __assign({}, rest);
        if (!_this.props.disableAlign)
            _this.attrs.align = align;
        if (!_this.props.disableCaption)
            _this.attrs.alt = alt;
        return _this;
    }
    return Image;
}(BlockAtom));
var ImagePlugin = /** @class */ (function (_super) {
    __extends(ImagePlugin, _super);
    function ImagePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = PLUGIN_NAME;
        _this.Controller = ImageController;
        _this.Schema = Image;
        return _this;
    }
    return ImagePlugin;
}(SylPlugin));
export { Image, ImageController, ImagePlugin };
//# sourceMappingURL=index.js.map